// WizardLaunch Pages
const WIZARDLAUNCHENTITY = '[WIZARDLAUNCH]';
export const NEXT_STEP = `${WIZARDLAUNCHENTITY} NEXT_STEP`;
export const PREV_STEP = `${WIZARDLAUNCHENTITY} PREV_STEP`;
export const SET_COURSE_DETAILS = `${WIZARDLAUNCHENTITY} SET_COURSE_DETAILS`;
export const SET_CDL_TYPE = `${WIZARDLAUNCHENTITY} SET_CDL_TYPE`;
export const SET_ENDORSEMENTS = `${WIZARDLAUNCHENTITY} SET_ENDORSEMENTS`;
export const SET_DIRECT_COURSES = `${WIZARDLAUNCHENTITY} SET_DIRECT_COURSES`;
export const SET_STATE_SELECTION = `${WIZARDLAUNCHENTITY} SET_STATE_SELECTION`;
export const SET_VIDEO_SELECTION = `${WIZARDLAUNCHENTITY} SET_VIDEO_SELECTION`;
export const SET_PERSONAL_INFO = `${WIZARDLAUNCHENTITY} SET_PERSONAL_INFO`;
export const PURCHASE_SUCCESS = `${WIZARDLAUNCHENTITY} PURCHASE_SUCCESS`;
export const PURCHASE_FAILURE = `${WIZARDLAUNCHENTITY} PURCHASE_FAILURE`;
export const FETCH_DYNAMIC_DATA_REQUEST = `${WIZARDLAUNCHENTITY} FETCH_DYNAMIC_DATA_REQUEST`;
export const FETCH_DYNAMIC_DATA_SUCCESS = `${WIZARDLAUNCHENTITY} FETCH_DYNAMIC_DATA_SUCCESS`;
export const FETCH_DYNAMIC_DATA_FAILURE = `${WIZARDLAUNCHENTITY} FETCH_DYNAMIC_DATA_FAILURE`;
export const SET_END_AFFIDAVIT_VALUE = `${WIZARDLAUNCHENTITY} SET_END_AFFIDAVIT_VALUE`;
export const SET_COURSE_RECOMMENDATION = `${WIZARDLAUNCHENTITY} SET_COURSE_RECOMMENDATION`;
export const RESET_DYNAMIC_DATA = `${WIZARDLAUNCHENTITY} RESET_DYNAMIC_DATA`;
export const SET_DYNAMIC_DATA = `${WIZARDLAUNCHENTITY} SET_DYNAMIC_DATA`;
export const REMOVE_ENDORSEMENT = `${WIZARDLAUNCHENTITY} REMOVE_ENDORSEMENT`;
export const SET_STEPS = `${WIZARDLAUNCHENTITY} SET_STEPS`;
export const SET_SHOW_STATE_STEP = `${WIZARDLAUNCHENTITY} SET_SHOW_STATE_STEP`;
export const SET_QUERY_PARAMS = `${WIZARDLAUNCHENTITY} SET_QUERY_PARAMS`;

// Cart pages
const CARTENTITY = '[CART]';
export const VALIDATE_COUPON_REQUEST = `${CARTENTITY} VALIDATE_COUPON_REQUEST`;
export const VALIDATE_COUPON_SUCCESS = `${CARTENTITY} VALIDATE_COUPON_SUCCESS`;
export const VALIDATE_COUPON_FAILURE = `${CARTENTITY} VALIDATE_COUPON_FAILURE`;
export const CLEAR_COUPON = `${CARTENTITY} CLEAR_COUPON`;
export const SET_CART_ITEMS = `${CARTENTITY} SET_CART_ITEMS`;
export const UPDATE_CART_TOTALS = `${CARTENTITY} UPDATE_CART_TOTALS`;
export const UPDATE_CART_DETAILS = `${CARTENTITY} UPDATE_CART_DETAILS`;
// Stripe Payment Action Types
export const PROCESS_STRIPE_PAYMENT_REQUEST = 'PROCESS_STRIPE_PAYMENT_REQUEST';
export const PROCESS_STRIPE_PAYMENT_SUCCESS = 'PROCESS_STRIPE_PAYMENT_SUCCESS';
export const PROCESS_STRIPE_PAYMENT_FAILURE = 'PROCESS_STRIPE_PAYMENT_FAILURE';

// PayPal Payment Action Types
export const PAYPAL_PAYMENT_SUCCESS = 'PAYPAL_PAYMENT_SUCCESS';
export const PAYPAL_PAYMENT_ERROR = 'PAYPAL_PAYMENT_ERROR';

//Module const
export const FETCH_START = 'FETCH_START';
export const FETCH_SUCCESS = 'FETCH_SUCCESS';
export const FETCH_ERROR = 'FETCH_ERROR';

const UIENTITY = '[UI]';
export const SHOW_MESSAGE = `${UIENTITY} SHOW_MESSAGE`;
export const HIDE_MESSAGE = `${UIENTITY} HIDE_MESSAGE`;

// Error Hnadling
const ERRORENTITY = '[ERROR]';
export const ERROR_DETAILS = `${ERRORENTITY} ERROR_DETAILS`;

// Courses
export const SET_SELECTED_COURSES = 'SET_SELECTED_COURSES';
export const REMOVE_SELECTED_COURSE = `${WIZARDLAUNCHENTITY} REMOVE_SELECTED_COURSE`;

// contact form
export const SUBMIT_CONTACT_FORM = 'SUBMIT_CONTACT_FORM';
export const SUBMIT_CONTACT_FORM_SUCCESS = 'SUBMIT_CONTACT_FORM_SUCCESS';
export const SUBMIT_CONTACT_FORM_FAILURE = 'SUBMIT_CONTACT_FORM_FAILURE';

//user info
export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGIN_INFO = 'USER_LOGIN_INFO';
export const USER_PROFILE_INFO = 'USER_PROFILE_INFO';
export const FETCH_USER_EXISTING_COURSE = 'FETCH_USER_EXISTING_COURSE';
export const FETCH_USER_EXISTING_COURSE_INFO =
  'FETCH_USER_EXISTING_COURSE_INFO';
export const STUDENT_LOGIN_LOADER = "STUDENT_LOGIN_LOADER";
export const USER_LOGOUT = 'USER_LOGOUT';

// Add these action types
export const CLEAR_ENDORSEMENTS = `${WIZARDLAUNCHENTITY} CLEAR_ENDORSEMENTS`;
export const CLEAR_MORE_CLASS_SELECTION = `${WIZARDLAUNCHENTITY} CLEAR_MORE_CLASS_SELECTION`;
export const REMOVE_DIRECT_COURSE = `${WIZARDLAUNCHENTITY} REMOVE_DIRECT_COURSE`;
